import styled from "styled-components";
import { MEDIA_DESKTOP } from "../../../../hooks/useScreenOrientation";

export const YoutubeWrapper = styled.div`
  width: 100%;
  margin-top: 32px;
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 6px;
`;

export const Title = styled.div`
  color: #000;

  font-size: 17.181px;
  font-style: normal;
  font-weight: 600;
  line-height: 25.771px; /* 150% */
  @media ${MEDIA_DESKTOP} {
    font-size: 24px;
  }
`;

export const ChannelList = styled.div`
  padding: 8px 4px 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;

  @media ${MEDIA_DESKTOP} {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
  }
`;

export const CardItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  width: 100%;
  height: 92px;
  cursor: pointer;
`;

export const ThumbnailWrapper = styled.div`
  width: 92px;
  height: 92px;
  border-radius: 8px;
`;

export const Thumbnail = styled.img`
  width: 92px;
  height: 92px;
  object-fit: cover;
  border-radius: 4px;
`;

export const TextWrapper = styled.div`
  width: 100%;
  height: 92px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  > .view-wrapper {
    display: flex;
    flex-direction: row;
    gap: 4px;
    align-items: center;
    > .views {
      text-align: center;
      color: var(--Black-300, #808080);

      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 140%; /* 19.6px */
      letter-spacing: -0.28px;
    }
    > img {
      width: 16px;
      height: 16px;
    }
  }
`;

export const Text = styled.div`
  color: var(--Black-400, #444);

  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.32px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  width: 100%;

  @media ${MEDIA_DESKTOP} {
    font-size: 14px;
    letter-spacing: -0.28px;
  }
`;
